import Model from "@tripian/model";
import React from "react";

type Props = {
  countriesCount: number;
  citiesCount: number;
  refDom: React.MutableRefObject<null>;
  t: (value: Model.TranslationKey) => string;
};

const OurCoverage: React.FC<Props> = ({
  countriesCount,
  citiesCount,
  refDom,
  t,
}) => {
  return (
    <section className="bg-neutral-100 py-28 rounded-[5rem]">
      <div className="flex flex-col justify-center items-center gap-2 mb-8 md:mb-4">
        <p className="text-primary-color font-inter text-lg md:text-2xl font-semibold md:tracking-widest uppercase text-center">
          {t("landing.ourCoverageStudy")}
        </p>
        <div className="w-12 h-[0.05rem] bg-primary-color" />
      </div>

      <div ref={refDom} className="max-w-6xl mx-auto px-6">
        <h2 className="text-center text-4xl md:text-5xl font-bold mb-28 mt-6">
          {t("landing.weHaveGotYouCoveredIn.titleStudy")}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-20 md:gap-8">
          <div className="text-center">
            <div className="text-[5.375rem]/[100%] font-semibold mb-2">
              {countriesCount}
            </div>
            <div className="text-xl/[2.5rem] font-normal">
              {t("landing.weHaveGotYouCoveredIn.countries")}
            </div>
          </div>
          <div className="text-center">
            <div className="text-[5.375rem]/[100%] font-semibold mb-2">
              {citiesCount}
            </div>
            <div className="text-xl/[2.5rem] font-normal">
              {t("landing.weHaveGotYouCoveredIn.cities")}
            </div>
          </div>
          <div className="text-center">
            <div className="text-[5.375rem]/[100%] font-semibold mb-2">4M</div>
            <div className="text-xl/[2.5rem] font-normal">
              {t("landing.weHaveGotYouCoveredIn.handPickedLocations")}
            </div>
          </div>
        </div>
        {/* <div className="grid grid-cols-1 md:grid-cols-4 gap-20 md:gap-8">
          <div className="text-center">
            <div className="text-xl/[2.5rem] font-normal">{t("landing.weHaveGotYouCoveredIn.study.restaurants")}</div>
          </div>
          <div className="text-center">
            <div className="text-xl/[2.5rem] font-normal">{t("landing.weHaveGotYouCoveredIn.study.toursActivities")}</div>
          </div>
          <div className="text-center">
            <div className="text-xl/[2.5rem] font-normal">{t("landing.weHaveGotYouCoveredIn.study.liveEventsTickets")}</div>
          </div>
          <div className="text-center">
            <div className="text-xl/[2.5rem] font-normal">{t("landing.weHaveGotYouCoveredIn.study.culturalLandmarks")}</div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default OurCoverage;
